import { createStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';
import palette from 'theme/palette';

export default ({ typography, breakpoints }: Theme) =>
  createStyles({
    iconYellow: {
      color: palette.navCompanyContextActions,
      fontSize: 22,
    },
    iconGreen: {
      color: palette.navAdmin,
      fontSize: 22,
    },
    iconGray: {
      color: palette.navSuperAdminActions,
      fontSize: 22,
    },
    iconBlue: {
      color: palette.navOperator,
      fontSize: 22,
    },
    maintenanceManual: {
      paddingTop: '10px',
      paddingLeft: '10px',
    },
    cardsContent: {
      display: 'flex',
    },
    alignCards: {
      marginTop: '32px',
      marginLeft: 20,
    },
    buttons: {
      margin: '40px auto',

      '& .MuiButtonBase-root': {
        fontFamily: 'Roboto',
        minWidth: 112,
        padding: 6,
        margin: '0 8px',
        fontSize: 12,
        fontWeight: typography.fontWeightMedium,
        borderRadius: 4,
      },
    },
    iconMaintenance: { marginRight: 5 },
    FormContainer: {
      display: 'flex',
      padding: '0px 25px',
      marginBottom: 24,
      alignItems: 'center',
      justifyContent: 'flex-start',

      '& .MuiOutlinedInput-adornedEnd': {
        height: 45,
        paddingRight: 7,
      },

      '& .MuiSvgIcon-root': {
        width: 16,
        height: 16,
      },
      '& .MuiGrid-item': {
        padding: '8px 3px',
      },
      '& .MuiCheckbox-root ': {
        margin: '0px 8px 0px 8px',
        padding: 0,
      },
    },
    textFieldContainer: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      maxWidth: '98%',
    },
    blockInstancesContainer: { padding: '0px !important' },
    subject: { marginRight: 8 },
    datePicker: {
      [breakpoints.up(500)]: {
        width: '47%',
      },
      [breakpoints.down(500)]: {
        width: '100%',
      },
    },
    deleteButtons: {
      marginTop: 15,
    },
    fields: {
      '& .MuiFormControl-fullWidth': { margin: '6px 0px' },
      '& .MuiOutlinedInput-multiline': { display: 'inline-table', padding: 14 },
    },
    maintenanceDetailsBoxActive: {
      border: `0.6px solid ${palette.green}`,
      borderRadius: 8,
      backgroundColor: palette.backgroundLightGreen,
      marginBottom: 8,
    },
    maintenanceDetailsBoxInactive: {
      border: `0.6px solid ${palette.red}`,
      borderRadius: 8,
      backgroundColor: palette.backgroundLightRed,
      marginBottom: 8,
    },
    maintenanceDetailsText: {
      fontSize: 12,
      margin: 12,
      color: palette.darkGray,
    },
    maintenanceTitle: {
      fontSize: 14,
      color: palette.gray,
      margin: '0px 0px 8px 0px',
    },
    maintenanceHistoryButton: {
      border: `1px solid ${palette.blue}`,
      color: palette.blue,
      fontSize: 12,
      marginRight: 8,
    },
    removeSessionsSwitch: {
      width: '100%',
      marginTop: 16,
      marginLeft: 6,
      '& .MuiTypography-body1': { fontSize: 12, marginLeft: 6 },
    },
    tooltipTitle: {
      marginLeft: 10,
      height: 16,
      cursor: 'pointer',
    },
    sessionRemovalAlert: {
      width: '100%',
    },
    sessionRemovalDivider: {
      width: '100%',
      marginTop: 16,
      marginBottom: 8,
    },
    sessionRemovalMaxLimit: {
      width: '50%',
      display: 'flex',
      alignItems: 'center',
    },
    removalMessage: { width: '100%', marginTop: 8 },
    sessionRemovalPeriodBlock: {
      width: '100%',
      marginTop: 16,
      marginBottom: 8,
    },
    sessionRemovalTimeRow: {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      marginBottom: 8,
      '& > div:first-of-type': { flex: 1, minWidth: 0 },
    },
  });

export const overrideModal = {
  content: {
    padding: 12,
    fontSize: '12px !important',
    maxHeight: 600,
    overflowX: 'auto',
    maxWidth: 700,
  },
};
